<template>
  <b-form
    class="reset-form custom-input-form preview"
    aria-live="assertive"
    @submit.stop.prevent="onSubmit"
  >
    <div class="login">
      <b-form-group :label="$t('form.login')" label-for="user-register-email" class="text-muted">
        <b-input-group>
          <b-form-input
            id="user-register-email"
            v-model.trim="form.email"
            name="user-register-email"
            :state="validateState('email')"
            aria-describedby="input-email-feedback"
            :placeholder="$t('form.email.label')"
            class="custom-form-input custom-form-input-class text-muted"
            @blur="onBlur('email')"
          >
            >
          </b-form-input>
          <b-form-invalid-feedback id="input-email-feedback">
            {{ $t('message.error.invalidEmail') }}
          </b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
    </div>

    <div class="margin-top-30">
      <b-button
        type="submit"
        class="btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
        :disabled="processing"
        variant="primary"
      >
        <p v-if="!processing">{{ $t('button.send.label') }}</p>
        <div v-if="processing">
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
          <b-spinner small type="grow"></b-spinner>
        </div>
      </b-button>
    </div>
  </b-form>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';

export default {
  name: 'ResetPasswordForm',
  data() {
    return {
      form: {
        email: '',
      },
      valid: false,
    };
  },
  computed: {
    processing() {
      return this.$store.getters.getProcessing;
    },
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onBlur(name) {
      this.$v.form[name].$touch();
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$store.commit('SET_PROCESSING', true);
      this.$emit('submit', this.form);
    },
  },
};
</script>

<style lang="scss" scoped></style>
